module.exports = __webpack_public_path__ + "img/magento-banner@2x.e4f25480.webp";